import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { backgroundImageFormate } from "./constants";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types.internal";

const getValue = (condition: boolean, satisfiedVal: string, unSatisfiedVal: string): string => {
    if (condition) {
        return satisfiedVal;
    } else {
        return unSatisfiedVal;
    }
};

const getBackgroundGradient = (theme: ITheme) =>
    `linear-gradient(270deg, #EEA39E 0%, ${theme.colors[theme.colorMode].background_Primary} 100%)`;

export const HalfCard = styled.div`
    padding-top: ${props => props.theme.spacing.medium};
`;

export const BullsEyeHalfCard = styled.div<{ backgroundImage: string; isOneLite: boolean }>`
    margin-top: ${props => "calc(" + getValue(props.isOneLite, "3", "2") + " * " + props.theme.spacing.large + ")"};
    padding-top: ${props => "calc(" + getValue(props.isOneLite, "3.9", "3") + " * " + props.theme.spacing.xLarge + ")"};
    background-image: ${props => backgroundImageFormate(props.backgroundImage)};
    background-size: cover;
    background-position-x: center;
    background-color: ${props => props.theme.colors[props.theme.colorMode].background_Primary};
    border-radius: ${props => props.theme.cornerRadius.xLarge} ${props => props.theme.cornerRadius.xLarge} 0px 0px;
    box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.1);
`;

export const DEAsset = styled.div`
    width: ${props => "calc(4.2 * " + props.theme.spacing.xxLarge + ")"};
    height: ${props => "calc(4 * " + props.theme.spacing.xxLarge + ")"};
    position: absolute;
    top: ${props => "calc(-1 * " + props.theme.spacing.xSmall + ")"};
    left: 50%;
    transform: translateX(-48%);
`;

export const SwiggyLogo = styled.div<{ isOneLite: boolean }>`
    position: absolute;
    top: ${props => (props.isOneLite ? "calc(4.3 * " + props.theme.spacing.xxLarge + ")" : 0)};
    left: 50%;
    transform: translateX(-50%);
`;

export const HalfCardContainer = styled.div<{ isOneLite: boolean }>`
    width: 100%;
    border-radius: ${props => props.theme.cornerRadius.large} ${props => props.theme.cornerRadius.large} 0px 0px;
    background: ${props =>
        getValue(props.isOneLite, "none", props.theme.colors[props.theme.colorMode].background_Primary)};
`;

export const HalfCardDetails = styled.div`
    width: 90%;
    margin: auto;
    text-align: center;
    padding-top: ${props => props.theme.spacing.xLarge};
    padding-bottom: ${props => props.theme.spacing.xLarge};
`;

export const HeadingText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xLarge,
}));

export const TitlePlan = styled.span`
    color: ${props => props.theme.colors[props.theme.colorMode].primary};
`;

export const TagLineHeader = styled.div(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing.xxSmall,
    marginBottom: theme.spacing.small,
}));

export const NoteVector = styled.div<{ isRight: boolean }>(({ isRight, theme }) => ({
    width: "80px",
    height: "1.5px",
    background: getBackgroundGradient(theme),
    transform: isRight ? "rotate(180deg)" : "rotate(0deg)",
}));

export const TagLine = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xxSmall} ${theme.spacing.xSmall}`,
    borderRadius: theme.cornerRadius.xxSmall,
    margin: `auto ${theme.spacing.xxSmall}`,
    backgroundColor: theme.colors[theme.colorMode].primary_Sub,
}));

export const SubTitles = styled.div`
    margin-bottom: ${props => props.theme.spacing.xxLarge};
`;

export const SkipButton = styled.div`
    margin-top: ${props => props.theme.spacing.large};
`;
